export { default } from './TrailMetadataStats';
